import { render, staticRenderFns } from "./Emailing.vue?vue&type=template&id=560c812c&scoped=true&"
import script from "./Emailing.vue?vue&type=script&lang=js&"
export * from "./Emailing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560c812c",
  null
  
)

export default component.exports